import { useReveal } from "@/hooks/useReveal";

export default function UFJPrivateClientBand({ onInquire }) {
  const eyebrow = useReveal();
  const title = useReveal();
  const lead = useReveal();

  return (
    <section
      data-testid="ufj-private-client-band"
      className="relative py-28 md:py-36 overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse at top, rgba(212,175,140,0.09) 0%, transparent 55%), #000",
      }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <p ref={eyebrow} className="pd-reveal eyebrow" data-testid="ufj-client-eyebrow">
          The Private Client Experience
        </p>
        <h2
          ref={title}
          className="pd-reveal mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl text-white tracking-[0.06em] leading-[1.06]"
          style={{ transitionDelay: "160ms" }}
          data-testid="ufj-client-title"
        >
          Begin a <span className="italic font-serif-body text-gold-gradient">private conversation.</span>
        </h2>
        <div ref={lead} className="pd-reveal mt-8" style={{ transitionDelay: "320ms" }}>
          <p className="font-serif-body italic text-lg md:text-xl text-white/80 leading-relaxed">
            Each client is received by a single concierge, from first dialogue to final delivery.
          </p>
          <p className="mt-5 text-white/55 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
            Request a private jewelry viewing, a bespoke consultation, or ask about a piece
            in confidence. Responses are personal, discreet, and sent within 72 hours.
          </p>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5">
          <button
            onClick={() => onInquire?.({ mode: "inquire" })}
            data-testid="ufj-client-inquire-btn"
            className="btn-gold"
          >
            <span>Inquire Privately</span>
          </button>
          <button
            onClick={() => onInquire?.({ mode: "commission" })}
            data-testid="ufj-client-consult-btn"
            className="btn-ghost"
          >
            Request a Private Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
